import { Img, Text } from "@react-email/components";
import { Layout, OrderSection, StyledButton } from "./components";

/**
 *
 * @param {Date} orderDate date of order (Date Object)
 * @param {(string | number)} orderNumber order number (string or number)
 * @param {Array<Object>} productList array of product objects with {img, name, price, quantity}
 * @param {Object} prices object with {subtotal, tax, shipping, total}
 * @param {string} address shipping address
 */
export default function OrderConfirmation({
	orderDate,
	orderNumber,
	productList,
	prices,
	address,
	name,
	phoneNumber,
}) {
	const utm_campaign = "order_confirmation_response";

	return (
		<Layout
			withNavBar
			utm_campaign={utm_campaign}
			preview="Thank you for your order!"
		>
			<Img
				src="https://offcutshades.com/images/email/someone-is-getting-new-shades.gif"
				alt="Samples"
				width="100%"
			/>
			<h3>Thank you for shopping with us!</h3>
			<Text>
				We are preparing your order and making sure everything is how you want
				it to be. It won't take long.{" "}
				<b>We will be shipping your order in the next 48 business hours.</b>
			</Text>
			<br />
			<br />
			<OrderSection
				orderNumber={orderNumber}
				orderDate={orderDate}
				productList={productList}
				prices={prices}
				address={address}
				name={name}
				phoneNumber={phoneNumber}
			/>
			<br />
			<Text>
				If you would like to learn more about fabric selection, click the link
				below to check our fabric guide.
			</Text>
			<div style={{ display: "flex", justifyContent: "space-around" }}>
				<StyledButton
					link={`https://offcutshades.com/help/installation-guide?utm_source=body&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`}
					text="Installation Guide"
				/>
				<StyledButton
					link={`https://offcutshades.com/help/shipping-policy?utm_source=body&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`}
					text="Shipping Information"
				/>
			</div>
			<Text>
				If you have any questions, please don't hesitate to{" "}
				<a
					href={`https://offcutshades.com/contact?utm_source=body&utm_medium=email&utm_campaign=${utm_campaign}&utm_id=ATemails`}
					style={{ color: "#ef4036 !important" }}
				>
					contact us
				</a>
				.
			</Text>
		</Layout>
	);
}
